namespace $ {

	type $shm_hitalama_chime_host = typeof globalThis & {
		AudioContext?: typeof AudioContext
		webkitAudioContext?: typeof AudioContext
	}

	export class $shm_hitalama_chime extends $mol_object2 {

		static readonly notes = [
			{ delay: 0, frequency: 659.25 },
			{ delay: .14, frequency: 523.25 },
		] as const

		static readonly partials = [
			{ ratio: 1, level: 1, decay: 1.15 },
			{ ratio: 2, level: .25, decay: .7 },
			{ ratio: 3, level: .09, decay: .45 },
		] as const

		static readonly peak_gain = .14
		static readonly attack_seconds = .012
		static readonly release_seconds = .05

		private audio_context?: AudioContext
		private audio_output?: GainNode

		audio( host: $shm_hitalama_chime_host ) {
			if( this.audio_context?.state === 'closed' ) {
				this.audio_context = undefined
				this.audio_output = undefined
			}
			if( this.audio_context ) return this.audio_context
			const Context = host.AudioContext ?? host.webkitAudioContext
			if( !Context ) return null
			const context = new Context()
			const output = context.createGain()
			output.gain.value = 1
			output.connect( context.destination )
			this.audio_context = context
			this.audio_output = output
			return context
		}

		prime( host: $shm_hitalama_chime_host ) {
			const context = this.audio( host )
			if( context?.state === 'suspended' ) void context.resume().catch( ()=> {} )
		}

		play( host: $shm_hitalama_chime_host, volume = .6 ) {
			const context = this.audio( host )
			const output = this.audio_output
			if( !context || !output ) return false
			const schedule = ()=> {
				if( context.state !== 'running' ) return
				this.synthesize( context, output, Math.min( Math.max( volume, 0 ), 1 ) )
			}
			if( context.state === 'suspended' ) void context.resume().then( schedule, ()=> {} )
			else schedule()
			return true
		}

		synthesize( context: AudioContext, output: AudioNode, volume: number ) {
			const start = context.currentTime + .01
			for( const note of $shm_hitalama_chime.notes ) {
				for( const partial of $shm_hitalama_chime.partials ) {
					const oscillator = context.createOscillator()
					const envelope = context.createGain()
					const onset = start + note.delay
					const level = Math.max( $shm_hitalama_chime.peak_gain * volume * partial.level, 1e-4 )
					oscillator.type = 'sine'
					oscillator.frequency.value = note.frequency * partial.ratio
					envelope.gain.setValueAtTime( 1e-4, onset )
					envelope.gain.exponentialRampToValueAtTime(
						level,
						onset + $shm_hitalama_chime.attack_seconds,
					)
					envelope.gain.exponentialRampToValueAtTime( 1e-4, onset + partial.decay )
					oscillator.connect( envelope ).connect( output )
					oscillator.start( onset )
					oscillator.stop( onset + partial.decay + $shm_hitalama_chime.release_seconds )
				}
			}
		}

	}

}
